import {jsonMapMember, jsonMember, jsonObject} from "typedjson";
import {DxListOptions} from "../list/dx-list-options";
import {DxNodeType} from "./dx-node-type";

@jsonObject
export class DxTreeListOptions extends DxListOptions {
  /** Мапа типов узлов дерева */
  @jsonMapMember(String, DxNodeType, {name: 'nodeTypes', emitDefaultValue: false, isRequired: false})
  private _nodeTypes: Map<string, DxNodeType>;

  /** мапа с параметрами фильтрации датасорса */
  @jsonMapMember(String, Object, {name: 'filter', emitDefaultValue: false, isRequired: false})
  private _filter: Map<string, Object>;

  get nodeTypes(): Map<string, DxNodeType> {
    return this._nodeTypes;
  }

  set nodeTypes(value: Map<string, DxNodeType>) {
    this._nodeTypes = value;
  }

  get filter(): Map<string, Object> {
    return this._filter;
  }

  set filter(value: Map<string, Object>) {
    this._filter = value;
  }
}
